export default "__VITE_ASSET__c6c28c8d__"